<template>
    <el-row :gutter="15">
        <el-col :span="8" :xs="24">
            <el-card>
                <div class="user">
                    <img src="../assets/images/user.png" alt="">
                    <div class="user-info">
                        <p class="name">Admin</p>
                        <p class="access">超级管理员</p>
                    </div>
                </div>
                <div class="login-info">
                    <p>上次登录时间: <span>2023-01-01</span></p>
                    <p>上次登录地点: <span>绍兴</span></p>
                </div>
            </el-card>
            <el-card style="margin-top: 20px; height: 460px;">
                <el-table :data="tableData">
                    <el-table-column v-for="(val, key) in tableLabel" :prop="key" :label="val" :key="key"></el-table-column>
                </el-table>
            </el-card>
        </el-col>
        <el-col :span="16" :xs="24">
            <div class="num">
                <el-card v-for="item in countData" :key="item.name" :body-style="{display: 'flex', padding: 0}">
                    <i class="icon" :class="`el-icon-${item.icon}`" :style="{background: item.color}"></i>
                    <div class="detail">
                        <p class="price">$ {{ item.value }}</p>
                        <p class="desc">{{ item.name }}</p>
                    </div>
                </el-card>
            </div>
        </el-col>
    </el-row>
</template>

<script>
import { getUsers, getDevices, login } from '../api'
export default {
    data() {
        return {
            tableData: [
                {
                    name: '用户',
                    todayAdd: 10,
                    monthAdd: 20,
                    totalAdd: 30
                },
                {
                    name: '宠物',
                    todayAdd: 40,
                    monthAdd: 50,
                    totalAdd: 60
                },
                {
                    name: '智能项圈',
                    todayAdd: 70,
                    monthAdd: 80,
                    totalAdd: 90
                }
            ],
            tableLabel: {
                name: "项目",
                todayAdd: "今日新增",
                monthAdd: "本月新增",
                totalAdd: "总价"
            },
            countData: [
                {
                    name: "今日支付订单",
                    value: 1234,
                    icon: "success",
                    color: "#2ec7c9"
                },
                {
                    name: "今日收藏订单",
                    value: 1234,
                    icon: "star-on",
                    color: "#ffb980"
                },
                {
                    name: "今日未支付订单",
                    value: 1234,
                    icon: "s-goods",
                    color: "#5ab1ef"
                },
                {
                    name: "本月支付订单",
                    value: 1234,
                    icon: "success",
                    color: "#2ec7c9"
                },
                {
                    name: "本月收藏订单",
                    value: 1234,
                    icon: "star-on",
                    color: "#ffb980"
                },
                {
                    name: "本月未支付订单",
                    value: 1234,
                    icon: "s-goods",
                    color: "#5ab1ef"
                }
            ]
        };
    },
/*    mounted() {
        login().then((data) => {
            console.log(data.data.data);
        });
    }*/
}
</script>

<style lang="less" scoped>
.user {
    display: flex;
    align-items: center;
    padding-bottom: 20px;
    margin-bottom: 20px;
    border-bottom: 1px solid #ccc;

    img {
        width: 150px;
        height: 150px;
        border-radius: 50%;
        margin-right: 40px;
    }

    .user-info {
        .name {
            font-size: 32px;
            margin-bottom: 10px;
        }

        .access {
            color: #999999;
        }
    }
}

.login-info {
    p {
        line-height: 28px;
        font-size: 14px;
        color: #999999;

        span {
            color: #666666;
            margin-left: 60px;
        }
    }
}

.num {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    .icon {
        width: 80px;
        height: 80px;
        font-size: 30px;
        color: #fff;
        text-align: center;
        line-height: 80px;
    }
    .detail {
        display: flex;
        flex-direction: column;
        justify-content: center;
        margin-left: 15px;
        .price {
            font-size: 30px;
            margin-bottom: 10px;
            line-height: 30px;
            height: 30px;
        }
        .desc {
            font-size: 14px;
            color: #999;
            text-align: center;
        }
    }
    .el-card {
        width: 32%;
        margin-bottom: 20px;
    }
}
</style>